import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { CosechaResponse } from "../../../shared/response/proyectos/CosechaResponse";
import { CosechaPayload } from "../../../shared/services/api/payload/proyectos/CosechaPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { CosechaService, toCosechaResponse } from "./CosechaService";

/** Alta y edición de cosechas; el resultado reemplaza la fila del listado. */
export class CosechaSaveService extends ServiceSaveBase<CosechaResponse, CosechaPayload> {
  protected readonly cache = CosechaService.instance;

  /**
   * gRPC-Web (`GuardarCosecha`): reemplaza siempre el set completo de tasas por categoría. Falla si la
   * cosecha ya está congelada. Las fechas ISO viajan como Unix ms.
   */
  protected async sendSave(p: CosechaPayload): Promise<CosechaResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarCosecha({
      id: p.id ?? undefined,
      nombre: p.nombre,
      anio: p.anio,
      tasaBaseIpc: p.tasaBaseIpc,
      fechaInicioVigencia: p.fechaInicioVigencia ? BigInt(Date.parse(p.fechaInicioVigencia)) : undefined,
      fechaFinVigencia: p.fechaFinVigencia ? BigInt(Date.parse(p.fechaFinVigencia)) : undefined,
      tasasPorCategoria: p.tasasPorCategoria.map((t) => ({ categoria: t.categoria, tasa: t.tasa })),
    }));
    return toCosechaResponse(r);
  }
}
